<template>
  <v-row justify="center">
    <v-dialog v-model="authCodeDialog" scrollable max-width="450px">
      <v-card>
        <v-card-title>{{ serial.serial_number }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="pb-7">
          <p class="font-weight-bold mt-7 body-2 black--text mb-2">
            매칭된 상품 정보
          </p>
          <p class="mb-0 font-weight-bold caption text-truncate">
            상품명 : {{ serial.product_name }}
          </p>
          <p class="mb-0 font-weight-bold caption text-truncate">
            품목명 : {{ serial.variant_name }}
          </p>
          <p class="mb-0 font-weight-bold caption text-truncate">
            상품코드 : {{ serial.product_code }}
          </p>
          <p class="mb-0 font-weight-bold caption text-truncate">
            품목코드 : {{ serial.variant_code }}
          </p>
          <template v-for="(history, key) in histories">
            <div v-bind:key="key">
              <p class="mb-0 font-weight-bold body-2 mt-9 black--text">
                {{ history.title }}
              </p>
              <p class="mb-0 caption text-truncate mt-1">
                <font class="black--text">{{ history.detail }}</font>
                <font>
                  <span v-if="history.detail !== history.changed_at"
                    >&nbsp;-&nbsp;{{ history.changed_at }}</span
                  >
                  ({{ history.updated_by }})
                </font>
              </p>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="authCodeDialog = false"
            >닫기</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      authCodeDialog: false,
      serial: {
        product_name: "",
        variant_name: "",
        product_code: "",
        variant_code: ""
      },
      histories: null
    };
  },
  mixins: [CommonMixin],
  methods: {
    authCodeClick: async function(data) {
      if (!data.serial_number) {
        this.authCodeDialog = false;
        return false;
      }
      try {
        let res = await M.api(
          M.entry("/serials/history", encodeURIComponent(data.serial_number))
        );

        this.serial = res.serial;
        this.histories = res.histories;
        this.authCodeDialog = true;
      } catch (e) {
        this.authCodeDialog = false;
      }
    }
  }
};
</script>
